import * as React from 'react';
import { Grid, Slider, Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';

import NumberElement from '../../../../utility/NumberElement';
import { isWeb, isTablet, isMobile } from '../../../../../lib/getDeviceSize';
import { get } from 'lodash';

import style from '../../../../../styles/sass/components/CompsChomper.module.scss';

export interface Props {
  classes: any;
  decimalScale: number;
  label: string;
  max: number;
  maxLabel: number;
  min: number;
  minLabel: number;
  onChange: any;
  percentage?: boolean;
  shortLabel: string;
  leftShortLabel?: string;
  rightShortLabel?: string;
  step: number;
  value: any;
  formatUnitValue?: boolean;
}

const styles = {
  bodyText: {
    fontSize: 12,
    lineHeight: '1.5',
    marginBottom: '0.35em',
  },
  sliderLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: isTablet() ? '1.25em' : '0.5em',
  },
  sliderParent: {
    marginRight: isWeb() ? '0%' : isTablet() ? '2%' : 0,
    width: isWeb() ? '33.33%' : isTablet() ? '45%' : '100%',
  },
  thumb: {
    backgroundColor: '#463264',
    borderRadius: 12.5,
    height: 25,
    width: 25,
  },
};

export class CompsSlider extends React.Component<Props, {}> {
  percentageFormatter = (value: number) => {
    return `${value > 0 ? '+' : ''}${value}%`;
  };

  standardFormatter = (value: number) => {
    return `${this.props.minLabel && value > 0 ? '+' : ''}${value}`;
  };

  render() {
    const {
      classes,
      decimalScale,
      label,
      max,
      min,
      maxLabel,
      minLabel,
      onChange,
      percentage,
      shortLabel,
      step,
      value,
    } = this.props;
    return (
      <Grid
        alignItems="center"
        className={`${style.sliderParent} col-xs-12 col-sm-12 col-md-4`}
        container
        style={styles.sliderParent}
      >
        <Grid item>
          <Typography gutterBottom align="left" className={classes.sliderLabel}>
            {label}
          </Typography>
        </Grid>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={isWeb() || isMobile() ? 3 : 2}>
            {minLabel >= 0 &&
              shortLabel !== 'mi' &&
              shortLabel !== 'months' &&
              shortLabel !== 'month' && (
                <div className={classes.bodyText} style={{ display: 'block' }}>
                  {shortLabel === '$' ? '$' : ''}
                  <NumberElement val={minLabel} decimalScale={0} />
                  {get(this.props, 'formatUnitValue', false) ? ' ' : <br />}
                  {shortLabel !== '$'
                    ? get(this.props, 'leftShortLabel', shortLabel)
                    : ''}
                  {percentage && <div>{value[0]}%</div>}
                </div>
              )}
          </Grid>
          <Grid item xs={isWeb() ? 6 : isTablet() ? 8 : 6}>
            <Slider
              aria-labelledby={`${label} slider`}
              getAriaValueText={
                percentage ? this.percentageFormatter : this.standardFormatter
              }
              min={min}
              max={max}
              onChange={onChange}
              step={step}
              value={value}
            />
          </Grid>
          <Grid item xs={isWeb() || isMobile() ? 3 : 2}>
            <div className={classes.bodyText}>
              {shortLabel === '$' ? '$' : ''}
              <NumberElement val={maxLabel} decimalScale={decimalScale} />
              {get(this.props, 'formatUnitValue', false) ? ' ' : <br />}
              {shortLabel !== '$'
                ? get(this.props, 'rightShortLabel', shortLabel)
                : ''}
              {percentage && <div>{value[1]}%</div>}
            </div>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const wrappedStyles = createStyles(styles);

export default withStyles(wrappedStyles)(CompsSlider);
